/**
 * HubSpot-hosted embed gate (staging safety).
 *
 * PR #518 made the HubSpot portal ID and GTM container env-driven so staging
 * stops touching prod services. Three-and-a-bit classes of embed could NOT be
 * fixed that way, because they are HubSpot-HOSTED properties bound to prod
 * portal 5417380 with no equivalent in the staging sandbox portal 51265320:
 *
 *   1. thankyou.getscw.com landing-page iframes — a form submitted inside one
 *      writes to the PRODUCTION CRM.
 *   2. meetings.hubspot.com booking embeds — a booking puts a real meeting on
 *      a real rep's calendar.
 *   3. cta-service-cms2.hubspot.com CTA anchors — the encrypted payload is
 *      portal-bound and cannot be re-signed, so a click pings prod tracking.
 *   4. hbspt.forms.create() embeds — the form IDs are portal-specific, so
 *      pointing them at the sandbox portal would 404 rather than isolate.
 *
 * Per CLAUDE.md non-negotiable #6 these embeds are never rewritten or
 * stripped. Instead each render site checks this flag and substitutes an inert
 * placeholder, leaving the real embed code path untouched.
 *
 * FAILS SAFE TOWARD PROD: the flag is opt-in-to-disable. An absent or
 * malformed value renders the live embed, which is exactly today's behavior.
 * Deriving this from the portal ID instead would be unsafe — HUBSPOT_PORTAL_ID
 * falls back to the literal prod portal when unset (src/lib/hubspot-forms.ts),
 * so a missing env on staging would silently re-enable prod writes.
 *
 * Set NEXT_PUBLIC_DISABLE_HUBSPOT_EMBEDS=true in the staging env only.
 */

// Referenced as a full literal so Next.js can inline it at build time.
export const HUBSPOT_EMBEDS_DISABLED =
  process.env.NEXT_PUBLIC_DISABLE_HUBSPOT_EMBEDS === 'true';
